/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Camera_Settings_Base_Url_HttpsInputs */

const vi_grower_camera_settings_base_url_https = /** @type {(inputs: Grower_Camera_Settings_Base_Url_HttpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ máy chủ camera phải dùng HTTPS`)
};

/**

* @param {Grower_Camera_Settings_Base_Url_HttpsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_camera_settings_base_url_https = /** @type {((inputs?: Grower_Camera_Settings_Base_Url_HttpsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Camera_Settings_Base_Url_HttpsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_camera_settings_base_url_https(inputs)
});